import { lazy } from 'react';

// project imports
import Loadable from 'ui-components/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
const Login = Loadable(lazy(() => import('views/pages/authentication/Login')));
const NotFound = Loadable(lazy(() => import('views/NotFound')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/login',
            element: <Login />
        },
        {
            path: '*',
            element: <NotFound />
        }
    ]
};

export default AuthenticationRoutes;
